import { useSnackbar } from "notistack";
import { useCallback, useState } from "react";

import { AjaxResult } from "../../../../../../enums/ajaxResult";
import { useApi } from "../../../../../useApi";

export function useAddOwner(boxId: number) {
    const { boxApi } = useApi();
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);

    const addOwner = useCallback((
        ownerId: number,
        leaseEndDate: string | null,
        setLeaseEndDate: boolean,
        onSuccess: () => void,
    ) => {
        setLoading(true);
        boxApi.addOwner(boxId, ownerId, leaseEndDate, setLeaseEndDate).then((r) => {
            if (r.result === AjaxResult.Success) {
                enqueueSnackbar("Owner added!", { variant: "success" });
                onSuccess();
            } else {
                enqueueSnackbar("Failed to add owner!", { variant: "error" });
            }
            setLoading(false);
        });
    }, [boxApi, boxId, enqueueSnackbar]);

    return { addOwner, loading };
}
